/**
 * global.js — Glucody (base IUROP)
 * Lógica base sin estilo. Controla la apertura/cierre del cart drawer (sidecart)
 * y del menú móvil mediante atributos data-*. Amplía a medida que construyes.
 */
(function () {
  'use strict';

  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('data-open', 'true');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }

  function closeDrawer(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-drawer-open');
  }

  // Shopify detecta el país por IP mediante su Ajax API. Si no está entre los
  // destinos publicados, se asigna el país de envío publicado más cercano; una
  // elección manual se respeta y nunca se vuelve a sobreescribir.
  function initMarketGeolocation() {
    var selector = document.querySelector('[data-glucody-market-selector]');
    if (!selector || !window.fetch || !window.Shopify) return;

    var allowed = (selector.getAttribute('data-supported-countries') || '')
      .split(',').filter(Boolean);
    if (!allowed.length) return;

    var geoKey = 'glucody:market-geolocation-applied';
    var manualKey = 'glucody:market-manual-selection';
    try {
      if (localStorage.getItem(geoKey) || localStorage.getItem(manualKey)) return;
    } catch (e) { return; }

    var nearest = {
      AD: 'AD', AE: 'IT', AR: 'PT', AT: 'DE', BE: 'FR', BG: 'IT', BH: 'IT',
      BR: 'PT', CH: 'IT', CL: 'PT', CN: 'DE', CO: 'PT', CY: 'IT', CZ: 'DE',
      DE: 'DE', DK: 'DE', EC: 'PT', EE: 'DE', ES: 'ES', FI: 'DE', FR: 'FR',
      GB: 'FR', GR: 'IT', GT: 'PT', HR: 'IT', HU: 'DE', IE: 'FR', IT: 'IT',
      LT: 'DE', LU: 'DE', LV: 'DE', MT: 'IT', MX: 'PT', NL: 'FR', NO: 'DE',
      PE: 'PT', PL: 'DE', PT: 'PT', QA: 'IT', RO: 'IT', SA: 'IT', SE: 'DE',
      SI: 'IT', SK: 'DE', TH: 'DE', US: 'PT', UY: 'PT'
    };
    var rootPath = (window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currentCountry = (window.Shopify.country || '').toUpperCase();
    var query = 'browsing_context_suggestions.json?country%5Benabled%5D=true'
      + '&country%5Bexclude%5D=' + encodeURIComponent(currentCountry)
      + '&language%5Benabled%5D=false';

    fetch(rootPath + query, { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('localization unavailable'); return response.json(); })
      .then(function (context) {
        try { if (localStorage.getItem(manualKey)) return; } catch (e) { return; }
        var detected = context && context.detected_values && context.detected_values.country;
        var detectedCode = (detected && detected.handle || '').toUpperCase();
        if (!detectedCode) return;

        var target = allowed.indexOf(detectedCode) !== -1
          ? detectedCode : (nearest[detectedCode] || 'ES');
        if (allowed.indexOf(target) === -1) target = allowed.indexOf('ES') !== -1 ? 'ES' : allowed[0];

        try { localStorage.setItem(geoKey, '1'); } catch (e) { return; }
        if (target === currentCountry) return;

        var form = document.createElement('form');
        form.method = 'post';
        form.action = rootPath + 'localization';
        form.hidden = true;
        form.setAttribute('data-geo-localization', '');
        [
          ['_method', 'put'],
          ['country_code', target],
          ['return_to', window.location.pathname + window.location.search]
        ].forEach(function (pair) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          input.value = pair[1];
          form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
      })
      .catch(function () { /* Geolocalización no disponible: mantener el mercado actual. */ });
  }

  document.addEventListener('submit', function (event) {
    if (event.target.matches('[data-geo-localization]')) return;
    if (event.target.querySelector('select[name="country_code"]')) {
      try { localStorage.setItem('glucody:market-manual-selection', '1'); } catch (e) {}
    }
  }, true);

  initMarketGeolocation();

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(document.querySelector('[data-cart-drawer]'));
      return;
    }

    var closeTrigger = event.target.closest('[data-cart-close], [data-drawer-overlay]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer(closeTrigger.closest('[data-cart-drawer]') || document.querySelector('[data-cart-drawer]'));
      return;
    }

    var menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      event.preventDefault();
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) menu.toggleAttribute('data-open');
      return;
    }

    // Desplegables de divisa/idioma del menú móvil ([data-loc]): botón
    // alterna su panel (cerrando el otro); elegir opción fija el <select>
    // oculto y envía el localization form; clic fuera cierra.
    var locOpt = event.target.closest('[data-loc-opt]');
    if (locOpt) {
      var loc = locOpt.closest('[data-loc]');
      var select = loc.querySelector('select');
      select.value = locOpt.getAttribute('data-loc-value');
      try { localStorage.setItem('glucody:market-manual-selection', '1'); } catch (e) {}
      select.form.submit();
      return;
    }

    var locToggle = event.target.closest('[data-loc-toggle]');
    document.querySelectorAll('[data-loc]').forEach(function (loc) {
      var panel = loc.querySelector('[data-loc-panel]');
      var btn = loc.querySelector('[data-loc-toggle]');
      if (!panel || !btn) return;
      if (locToggle && loc.contains(locToggle)) {
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        loc.classList.toggle('is-open', open);
        if (open) {
          var active = panel.querySelector('.is-active');
          if (active) active.scrollIntoView({ block: 'center' });
        }
      } else {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        loc.classList.remove('is-open');
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer(document.querySelector('[data-cart-drawer][data-open]'));
    }
  });
})();
